// Счётчик фоновых очередей (recording chunks + tutor messages) для OfflineBanner.
// Модули outbox пушат число через setPendingSyncCount; UI подписывается хуком.

type Listener = (count: number) => void;

const counts = new Map<string, number>();
const listeners = new Set<Listener>();

function total(): number {
	let sum = 0;
	for (const n of counts.values()) sum += n;
	return sum;
}

function emit(): void {
	const n = total();
	for (const l of listeners) l(n);
}

/** Источник: `recording` | `tutor-messages` | … */
export function setPendingSyncCount(source: string, count: number): void {
	const next = Math.max(0, count);
	if (counts.get(source) === next) return;
	counts.set(source, next);
	emit();
}

export function getPendingSyncCount(): number {
	return total();
}

export function subscribePendingSyncCount(listener: Listener): () => void {
	listeners.add(listener);
	listener(total());
	return () => {
		listeners.delete(listener);
	};
}
